import React, { useEffect, useState } from 'react';
import { Col, Row, Table, Spin } from "antd";
import { useSelector } from "react-redux";

import { getOrdersList } from '../../redux/dashboard/dashboardActions';
import { formatCurrency, formatDate, parseDate } from '../../utils/utils';

const OrdersTable = () => {
  const [spinStatus, setSpinStatus] = useState(false);

  const { ordersList } = useSelector((state) => state.dashboard);

  useEffect(async () => {

    setSpinStatus(true);
    await getOrdersList({ cardCode: localStorage.getItem('cardCode') });
    setSpinStatus(false);

  }, []);

  const columns = [
    {
      title: "Order",
      dataIndex: "ordNum",
      key: "ordNum",
      width: 100,
      fixed: 'left',
      sorter: (a, b) => a.ordNum - b.ordNum,
      filterSearch: true,
      filters: [...new Set(ordersList?.map(item => item.ordNum))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.ordNum === value,
    },
    {
      title: "Ref No",
      dataIndex: "refNo",
      key: "refNo",
      width: 100,
      sorter: (a, b) => a.refNo - b.refNo,
      filterSearch: true,
      filters: [...new Set(ordersList?.map(item => item.refNo))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.refNo === value,
    },
    {
      title: "Equipment ID",
      dataIndex: "equipId",
      key: "equipId",
      width: 100,
      sorter: (a, b) => (a.equipId || '').localeCompare(b.equipId || ''),
      filterSearch: true,
      filters: [...new Set(ordersList?.map(item => item.equipId))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.equipId === value,
    },
    {
      title: "Ship Method",
      dataIndex: "shipMethod",
      key: "shipMethod",
      width: 150,
      sorter: (a, b) => (a.shipMethod || '').localeCompare(b.shipMethod || ''),
      filterSearch: true,
      filters: [...new Set(ordersList?.map(item => item.shipMethod))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.shipMethod === value,
    },
    {
      title: "Order Date",
      dataIndex: "postingDate",
      key: "postingDate",
      width: 100,
      render: (text, record) => <div className={'hp-text-center'}>{formatDate(record.postingDate)}</div>,
      sorter: (a, b) => {
        const dateA = parseDate(a.postingDate);
        const dateB = parseDate(b.postingDate);
        if (!dateA && !dateB) return 0;
        if (!dateA) return -1;
        if (!dateB) return 1;
        return dateA.valueOf() - dateB.valueOf();
      },
      filterSearch: true,
      filters: [...new Set(ordersList?.map(item => item.postingDate))].map(val => ({ text: formatDate(val), value: val })),
      onFilter: (value, record) => record.postingDate === value,
    },
    {
      title: "Delivery Date",
      dataIndex: "delDate",
      key: "delDate",
      render: (text, record) => <div className={'hp-text-center'}>{formatDate(record.delDate)}</div>,
      sorter: (a, b) => {
        const dateA = parseDate(a.delDate);
        const dateB = parseDate(b.delDate);
        if (!dateA && !dateB) return 0;
        if (!dateA) return -1;
        if (!dateB) return 1;
        return dateA.valueOf() - dateB.valueOf();
      },
      width: 100,
      filterSearch: true,
      filters: [...new Set(ordersList?.map(item => item.delDate))].map(val => ({ text: formatDate(val), value: val })),
      onFilter: (value, record) => record.delDate === value,
    },
    {
      title: "Total QTY",
      dataIndex: "quantity",
      key: "quantity",
      width: 80,
      render: (text, record) => <div className={'hp-text-center'}>{text}</div>,
      sorter: (a, b) => a.quantity - b.quantity,
      filterSearch: true,
      filters: [...new Set(ordersList?.map(item => item.quantity))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.quantity === value,
    },
    {
      title: "Amount",
      dataIndex: "total",
      key: "total",
      width: 100,
      render: (text, record) => <div className={'hp-text-right'}>{formatCurrency(record.total)}</div>,
      sorter: (a, b) => a.total - b.total,
      filterSearch: true,
      filters: [...new Set(ordersList?.map(item => item.total))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.total === value,
    },
  ];

  return (
    <Spin spinning={spinStatus} size="large">
      <Row gutter={[18, 18]}>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={ordersList}
            rowKey="order"
            pagination={{
              position: ['bottomCenter'],
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ['10', '25', '50', '100'],
            }}
            scroll={{ x: '1000px' }}
            size="small"
            bordered
          />
        </Col>
      </Row>
    </Spin>
  );
};

export default OrdersTable;